<div class="maintenance" [class.fill]="isFill">
  <div class="maintenance-container">
    <div class="maintenance-block">
      <h3 class="maintenance-block-title">{{ 'MAINTENANCE.' + title | translate }}</h3>
      <p class="maintenance-block-description fill">{{ 'MAINTENANCE.' + description | translate }}</p>
    </div>
  </div>
</div>
